import { useEffect, useState } from 'react';
import { useConfig } from '../../../../contexts/config-context';
import { useFieldActions } from '../../../../contexts/field-actions-context';
import { bulkSlotsSize, DataStatus, ErrorTypes } from '../../appointment-state';
import { Actions, Components } from '../../bi-types';
import { useAppointmentBi } from '../../utils/bi';
import { calculateSelectedDate, getStartAndEndDate, getUserTimezone } from './utils';
export default function useInitialAppointmentState(props) {
    const { initialData: loadInitialAppointmentDataResponse, onChange, value: selectedSlotFromProps } = props;
    const { isEditor, isComposer, instance } = useConfig();
    const serviceId = loadInitialAppointmentDataResponse?.service?.id;
    const { actions } = useFieldActions();
    const [appointmentState, setAppointmentState] = useState(null);
    const bi = useAppointmentBi(loadInitialAppointmentDataResponse?.service);
    useEffect(()=>{
        const initialAppointmentState = async ()=>{
            const timezone = getUserTimezone();
            const appointmentStateResult = {
                currentSlotBulkSize: bulkSlotsSize,
                timezone,
                dataStatus: DataStatus.LOADING
            };
            try {
                const fetchAvailabilityDates = async (range)=>{
                    const { startDate, endDate } = getStartAndEndDate(range, timezone);
                    return actions?.getAvailabilityDates?.({
                        serviceId: serviceId,
                        fromDate: startDate,
                        toDate: endDate,
                        timeZone: timezone
                    });
                };
                appointmentStateResult.availabilityDates = await fetchAvailabilityDates(2);
                if (!appointmentStateResult.availabilityDates?.length) {
                    appointmentStateResult.availabilityDates = await fetchAvailabilityDates(6);
                }
                if (!appointmentStateResult.availabilityDates?.length) {
                    bi?.report({
                        action: Actions.LOAD,
                        component: Components.NO_AVAILABILITY_AT_ALL
                    });
                    setAppointmentState({
                        dataStatus: DataStatus.ERROR,
                        error: {
                            type: ErrorTypes.NO_AVAILABILITY_DATES_FOUND,
                            message: 'No availability dates found'
                        }
                    });
                    return;
                }
                appointmentStateResult.selectedDate = calculateSelectedDate(appointmentStateResult.availabilityDates);
                if (appointmentStateResult.selectedDate) {
                    appointmentStateResult.availabilitySlots = await actions?.getAvailabilitySlots?.({
                        serviceId: serviceId,
                        timeZone: timezone,
                        selectedDate: appointmentStateResult.selectedDate
                    });
                }
                bi?.report({
                    action: Actions.LOAD,
                    component: appointmentStateResult.availabilityDates?.length ? Components.FORM : Components.NO_AVAILABILITY_FOR_DATE
                });
                if (!selectedSlotFromProps?.startDate) {
                    onChange(undefined);
                }
                setAppointmentState({
                    ...appointmentStateResult,
                    dataStatus: DataStatus.DONE
                });
            } catch (error) {
                console.error(error);
                setAppointmentState({
                    dataStatus: DataStatus.ERROR,
                    error: {
                        type: ErrorTypes.GENERAL,
                        message: 'An error occurred in initialAppointmentState'
                    }
                });
            }
        };
        if (serviceId && !isEditor && !isComposer && actions?.getAvailabilitySlots && actions?.getAvailabilityDates && !!instance) {
            initialAppointmentState();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isEditor,
        isComposer,
        serviceId,
        actions?.getAvailabilitySlots,
        actions?.getAvailabilityDates,
        instance
    ]);
    return appointmentState;
}

//# sourceMappingURL=index.js.map